import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "file_content_type": {
      "column": null,
      "name": "file_content_type",
      "selected_by_default": null,
      "translated": null
    },
    "file_name": {
      "column": null,
      "name": "file_name",
      "selected_by_default": null,
      "translated": null
    },
    "file_size": {
      "column": null,
      "name": "file_size",
      "selected_by_default": null,
      "translated": null
    },
    "file_url": {
      "column": null,
      "name": "file_url",
      "selected_by_default": null,
      "translated": null
    },
    "height": {
      "column": null,
      "name": "height",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_id": {
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": null
      },
      "name": "resource_id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "width": {
      "column": null,
      "name": "width",
      "selected_by_default": null,
      "translated": null
    },
    "preview_image_path": {
      "column": null,
      "name": "preview_image_path",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "TrixFile",
  "collectionKey": "trix_files",
  "collectionName": "trix_files",
  "i18nKey": "trix_file",
  "camelizedLower": "trixFile",
  "name": "TrixFile",
  "nameDasherized": "trix-file",
  "pluralName": "trix_files",
  "ransackable_associations": [
    {
      "className": "TrixFile::Audit",
      "collectionName": "trix_file_audits",
      "foreignKey": "trix_file_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "TrixFileAudit",
      "through": null
    },
    {
      "className": "TrixFile::Audit",
      "collectionName": "trix_file_audits",
      "foreignKey": "trix_file_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "TrixFileAudit",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": null,
      "foreignKey": "record_id",
      "name": "file_attachment",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": null,
      "foreignKey": "blob_id",
      "name": "file_blob",
      "macro": "has_one",
      "resource_name": null,
      "through": "file_attachment"
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": null,
      "foreignKey": "record_id",
      "name": "preview_image_attachment",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": null,
      "foreignKey": "blob_id",
      "name": "preview_image_blob",
      "macro": "has_one",
      "resource_name": null,
      "through": "preview_image_attachment"
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "key",
      "column": {
        "default": null,
        "name": "key",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "trix_file",
  "primaryKey": "id"
}

/** Frontend model for TrixFile. */
class TrixFile extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  fileContentType() {
    return this.readAttributeUnderscore("file_content_type")
  }

  /** @returns {boolean} */
  hasFileContentType() {
    const value = this.fileContentType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  fileName() {
    return this.readAttributeUnderscore("file_name")
  }

  /** @returns {boolean} */
  hasFileName() {
    const value = this.fileName()

    return this._isPresent(value)
  }

  /** @returns {any} */
  fileSize() {
    return this.readAttributeUnderscore("file_size")
  }

  /** @returns {boolean} */
  hasFileSize() {
    const value = this.fileSize()

    return this._isPresent(value)
  }

  /** @returns {any} */
  fileUrl() {
    return this.readAttributeUnderscore("file_url")
  }

  /** @returns {boolean} */
  hasFileUrl() {
    const value = this.fileUrl()

    return this._isPresent(value)
  }

  /** @returns {any} */
  height() {
    return this.readAttributeUnderscore("height")
  }

  /** @returns {boolean} */
  hasHeight() {
    const value = this.height()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  resourceId() {
    return this.readAttributeUnderscore("resource_id")
  }

  /** @returns {boolean} */
  hasResourceId() {
    const value = this.resourceId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  width() {
    return this.readAttributeUnderscore("width")
  }

  /** @returns {boolean} */
  hasWidth() {
    const value = this.width()

    return this._isPresent(value)
  }

  /** @returns {any} */
  previewImagePath() {
    return this.readAttributeUnderscore("preview_image_path")
  }

  /** @returns {boolean} */
  hasPreviewImagePath() {
    const value = this.previewImagePath()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static remove(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callCollectionCommand(
      {
        args,
        command: "remove",
        collectionName: "trix_files",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static upload(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callCollectionCommand(
      {
        args,
        command: "upload",
        collectionName: "trix_files",
        type: "collection"
      },
      commandArgs
    ))
  }
}

export default TrixFile
